import React from 'react'
import PropTypes from 'prop-types'
import NRTFormInput from '../../../../../_common/_form/FormInput'
import { Validators } from '../../../../../_common/_form/Validators'


const QuestionMultipleChoices = (props) => {
    const code = props.code
    const answer = props.answer && props.answer
    const disabled = props.isReview
    return (
        <div>
            <NRTFormInput
                name={code}
                type={'radiogroup'}
                validators={[Validators.required()]}
                value={answer}
                disabled={disabled}
                customProps={{
                    options: props.optionDTOs.sort((a, b) => (a.order - b.order)).map((option) => ({
                        display: option.text,
                        value: option.code
                    }))
                }}
            />
        </div>
    )
}


QuestionMultipleChoices.propTypes = {
    id: PropTypes.string,
    statements: PropTypes.arrayOf(PropTypes.string)
}

QuestionMultipleChoices.defaultProps = {}


export default QuestionMultipleChoices



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Questions/QuestionMultipleChoices.js